import axios from 'axios'
import React, { useRef, useState } from 'react'
import { HighlightOff } from '@mui/icons-material'
import toast from 'react-hot-toast'
import { Url } from '../services/Constants'
import { setHeader } from '../services/Headers'
import { useNavigate } from 'react-router-dom'

export default function Addaddress({data}) {

    const Navigate = useNavigate()
    const pincode = useRef()
    const address = useRef()

    const [pincodeData,setPincodeData] = useState()

    const pincodeFinder = async()=>{
        if(pincode.current.value){
            try {
                const data= pincode.current.value
                const result = await axios.get(`https://api.postalpincode.in/pincode/${data}`)
                if(result.data[0].Status === "Success"){
                setPincodeData(result.data[0].PostOffice[0])
                }else{
                    setPincodeData(null)
                    toast.error("Please Enter Correct Pincode")
                }
            } catch (error) {
                console.log(error)
            }
        }
        else{
            setPincodeData(null)
        }
    }


    const addAddress = async()=>{
        if(!address.current.value){
            toast.error("Please Enter Address!")

        }else{
            const data ={
                street_address:address.current.value,
                city:pincodeData.District,
                state:pincodeData.State,
                pincode:pincode.current.value
            }
            try {
                const result = await axios.post(`${Url}/buyer/addresses`,data,setHeader())
                if(result.data.response_code==200){
                    toast.success("Address added Successfully.")
                    Navigate("/address")
                }
                else{
                    toast.error("Somthing Went Wrong!")
                }
            } catch (error) {
                console.log(error)
            }

        }
    }


    const disableHande =()=>{
        toast.error("Please Enter Pincode!")
    }




  return (
    <div className=" add-address-container w-full h-screen bg-opacity-75 bg-black flex top-0 justify-center items-center fixed z-50 ">
        <div className="address-modal w-96 bg-gray-300 rounded-2xl shadow-2xl z-40 max-sm:w-[90%]">
          <div className="address-modal-top w-full mx-auto flex flex-col items-center">
            <div className="title mt-1 border-b border-b-amber-950 w-[95%] text-center">
                <div className="close text-end  ">
                <HighlightOff sx={{ fontSize: 28 }} className="hover:bg-red-700 hover:text-white cursor-pointer  rounded-full m-0 p-0" onClick={data}/>
                </div>
                <span className='text-amber-950 font-bold text-2xl'>Add Address</span>
            </div>
            <div className="disabled w-full flex justify-center" onClick={disableHande}>
            <input type="text" value={pincodeData?pincodeData.State:""} name="" id="" className='outline-none rounded-xl mx-auto w-[90%] my-3 py-2 px-1 text-amber-950 bg-slate-100' placeholder='State' disabled/>
            </div>
            <div className="disabled w-full flex justify-center" onClick={disableHande}>
            <input type="text" value={pincodeData?pincodeData.District:""} name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950 bg-slate-100' placeholder='City' disabled />
            </div>
            <input type="text" name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950' ref={pincode} placeholder='Pincode' onBlur={pincodeFinder} maxLength={6} autoFocus/>
            <input type="text" name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950 resize-none' ref={address} placeholder='Address'/>
            <button className='block bg-amber-950 text-white px-5 py-1 rounded-lg mb-4 cursor-pointer' onClick={addAddress}>Add</button>
          </div>
          <div className="address-modal-bottom flex flex-col justify-center items-center">        
            
          </div>
        </div>
      </div>
  )
}
